<div class="w-full flex flex-col gap-2">
  <div class="flex flex-col gap-2">
    <span class="font-light text-[16px]">Start time</span>
    <div
      class="flex justify-between items-center h-10 py-3 px-4 rounded-[16px] border border-black"
      #button
      role="combobox"
      (focus)="open()"
      [attr.aria-expanded]="opened"
      #trigger="cdkOverlayOrigin"
      cdkOverlayOrigin
      (click)="open()"
    >
      <span class="text-[14px]">
        {{ time.hour | padStart : 2 }}:{{ time.minute | padStart : 2 }}
      </span>
      <ng-icon name="hugeTime02" size="16"></ng-icon>
    </div>
  </div>
  <div class="flex flex-col gap-2">
    <ui-counter
      [style]="'timer'"
      [max]="maxHours()"
      [description]="'Duration'"
      (quantityEmitter)="getCounterNumber($event)"
      class="text-[14px]"
      >{{ numberHours }} hour(s)</ui-counter
    >
  </div>
  @if(!isOpenSpace()) {
  <div class="flex flex-col gap-2">
    <span class="font-light text-[16px]">Available slots</span>
    <div class="w-full h-full grid grid-cols-2 gap-2 text-[14px]">
      @for (availableSlot of availableSlots(); track $index) {
      <div
        class="rounded-[48px] border col-span-1 px-4 py-1 border-neutral-50 text-neutral-50"
      >
        {{ availableSlot.startTime | slice : 0 : 5 }}-{{
          availableSlot.endTime | slice : 0 : 5
        }}
      </div>
      }
    </div>
  </div>
  }
</div>

<ng-template
  cdkConnectedOverlay
  (overlayOutsideClick)="close()"
  (backdropClick)="close()"
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="opened"
  [cdkConnectedOverlayPositions]="[
    {
      originX: 'start',
      originY: hasBottomSpace ? 'bottom' : 'top',
      overlayX: 'start',
      overlayY: hasBottomSpace ? 'top' : 'bottom',
      offsetX: 0,
      offsetY: hasBottomSpace ? 3 : -3
    }
  ]"
>
  <ui-timer
    [isOpenSpace]="isOpenSpace()"
    [currentHour]="time.hour"
    [currentMinute]="time.minute"
    (currentTime)="getTime($event)"
    [bookingDay]="bookingDay()"
    [availableSlots]="availableSlots()"
  ></ui-timer>
</ng-template>
